import Navbar from "./components/Navbar/navbar";

export default function Header() {

  return (
    <Navbar />
  );
}
